import React, { useState } from "react";
import { Button, TextField, MenuItem } from "@mui/material";

const FinancialYearManager = ({ financialYears, setFinancialYears, selectedYear, setSelectedYear }) => {
  const [newYear, setNewYear] = useState("");
  const [isEditing, setIsEditing] = useState(false);

  const addFinancialYear = () => {
    if (financialYears[newYear]) {
      alert("Financial Year already exists!");
      return;
    }
    setFinancialYears({ ...financialYears, [newYear]: [] });
    setNewYear("");
  };

  const deleteFinancialYear = (year) => {
    const newFinancialYears = { ...financialYears };
    delete newFinancialYears[year];
    setFinancialYears(newFinancialYears);
    if (selectedYear === year) setSelectedYear("");
  };

  const editFinancialYear = (year) => {
    setNewYear(year);
    setIsEditing(true);
    setSelectedYear(year);
  };

  const saveEditedYear = () => {
    if (financialYears[newYear] === undefined) {
      alert("Financial Year already exists!");
      return;
    }
    const updatedYears = { ...financialYears };
    delete updatedYears[selectedYear];
    updatedYears[newYear] = financialYears[selectedYear];
    setFinancialYears(updatedYears);
    setSelectedYear(newYear);
    setNewYear("");
    setIsEditing(false);
  };

  return (
    <div>
      <TextField
        label="Enter Financial Year (e.g. 2024-25)"
        variant="outlined"
        fullWidth
        value={newYear}
        onChange={(e) => setNewYear(e.target.value)}
      />
      {!isEditing ? (
        <Button variant="contained" color="primary" onClick={addFinancialYear}>Add Financial Year</Button>
      ) : (
        <Button variant="contained" color="secondary" onClick={saveEditedYear}>Save Edited Year</Button>
      )}
      <TextField
        select
        label="Select Financial Year"
        variant="outlined"
        fullWidth
        value={selectedYear}
        onChange={(e) => setSelectedYear(e.target.value)}
      >
        {Object.keys(financialYears).map((year) => (
          <MenuItem key={year} value={year}>
            {year}
            <Button variant="outlined" size="small" color="error" onClick={() => deleteFinancialYear(year)} style={{ marginLeft: "10px" }}>Delete</Button>
            <Button variant="outlined" size="small" color="primary" onClick={() => editFinancialYear(year)} style={{ marginLeft: "10px" }}>Edit</Button>
          </MenuItem>
        ))}
      </TextField>
    </div>
  );
};

export default FinancialYearManager;
